import useUser from "./useUser";
import getCompanyId from "src/utils/getCompanyId";

export default function useIsOwn(item?: object) {
  const { user } = useUser();
  const itemCompanyId = getCompanyId(item);

  return user && user?.companyId === itemCompanyId;
}
